/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Title, Text, Layout } from '../Terms/components';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <Layout title='Quem Somos'>
      <Title>{t('pages.aboutUs.title')}</Title>
      <Text>
        {t('pages.aboutUs.text')}
      </Text>
    </Layout>
  );
};

export default AboutUs;